import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";

import { PATH_PRIVACY } from "../routes/paths";

/**
 * TermsCheckboxes
 *
 * Props:
 *   - values: { termini, privacy, consenso, ugoTermini, ugoPrivacy, ugoConsenso }  (boolean each)
 *   - onChange: (name: string) => (event) => void
 *   - isFormik: bool — if true, onChange receives the name and returns a plain handler
 *                       compatible with both Formik (handleChange) and useState patterns
 *   - checkboxSx: optional sx override for each Checkbox
 */
export default function TermsCheckboxes({ values, onChange, checkboxSx = {} }) {
  const cbSx = {
    m: 0,
    p: 0,
    ml: "-2px",
    pr: ".7rem",
    color: "#6369E9",
    borderBlockColor: "#707070",
    ...checkboxSx,
  };

  const labelSx = {
    m: 0,
    pt: ".7rem",
    width: "100%",
    alignItems: "flex-start",
  };

  return (
    <Box>
      {/* ── Testo introduttivo ─────────────────────────────────────── */}
      <Typography sx={{ fontSize: "11px", pt: 1, pb: 0.5 }}>
        Prima di completare la registrazione alla Piattaforma, l'utente è tenuto
        a leggere attentamente e ad accettare:
      </Typography>

      {/* ── Sezione a) The Bloc ─────────────────────────────────────── */}
      <Typography sx={{ fontSize: "11px", pt: 1, pb: 0.5 }}>
        <strong>a)</strong> i presenti{" "}
        <Link
          href={PATH_PRIVACY.main.terminiCondizioni}
          color="#000000"
          sx={{ fontWeight: "bold" }}
          target="_blank"
          rel="noopener"
        >
          Termini e Condizioni d'Uso della Piattaforma
        </Link>
        , nonché l'{" "}
        <Link
          href={PATH_PRIVACY.main.informativa}
          color="#000000"
          sx={{ fontWeight: "bold" }}
          target="_blank"
          rel="noopener"
        >
          Informativa Privacy di The Bloc Italy
        </Link>
        , relativa al trattamento dei dati personali effettuato da The Bloc
        Italy;
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            id="termini"
            name="termini"
            checked={!!values.termini}
            onChange={onChange("termini")}
            sx={cbSx}
            required
          />
        }
        label={
          <Typography variant="body2" sx={{ fontSize: "11px" }}>
            Accetto i{" "}
            <Link
              href={PATH_PRIVACY.main.terminiCondizioni}
              color="#000000"
              sx={{ fontWeight: "bold" }}
              target="_blank"
              rel="noopener"
            >
              Termini e Condizioni
            </Link>{" "}
            di The Bloc Italy
          </Typography>
        }
        sx={labelSx}
      />

      <FormControlLabel
        control={
          <Checkbox
            id="privacy"
            name="privacy"
            checked={!!values.privacy}
            onChange={onChange("privacy")}
            sx={cbSx}
            required
          />
        }
        label={
          <Typography variant="body2" sx={{ fontSize: "11px" }}>
            Accetto l'{" "}
            <Link
              href={PATH_PRIVACY.main.informativa}
              color="#000000"
              sx={{ fontWeight: "bold" }}
              target="_blank"
              rel="noopener"
            >
              Informativa Privacy
            </Link>{" "}
            di The Bloc Italy
          </Typography>
        }
        sx={labelSx}
      />

      <FormControlLabel
        control={
          <Checkbox
            id="consenso"
            name="consenso"
            checked={!!values.consenso}
            onChange={onChange("consenso")}
            sx={cbSx}
            required
          />
        }
        label={
          <Typography variant="body2" sx={{ fontSize: "11px" }}>
            Consenso al trattamento dei dati per le finalità indicate
            nell'informativa
          </Typography>
        }
        sx={labelSx}
      />

      {/* ── Sezione b) UGO ──────────────────────────────────────────── */}
      <Typography sx={{ fontSize: "11px", pt: 1.5, pb: 0.5 }}>
        <strong>b)</strong> i{" "}
        <Link
          href="https://assets.ctfassets.net/sqy8sbi9hlp9/2ZfieTheM9dh3s6oduloRg/770b144744e2ba1b3d8878cbabf9718f/T_C_SHORT_UGO_31.03.2026.pdf"
          color="#000000"
          sx={{ fontWeight: "bold" }}
          target="_blank"
          rel="noopener"
        >
          termini e condizioni d'uso
        </Link>{" "}
        e l'{" "}
        <Link
          href="https://hellougo.com/static/a60c14745611b0466d5e990484651da3/UGO_PP_Ugo.pdf"
          color="#000000"
          sx={{ fontWeight: "bold" }}
          target="_blank"
          rel="noopener"
        >
          informativa privacy
        </Link>{" "}
        applicabili ai Servizi erogati dai Professionisti o dai fornitori terzi,
        che disciplinano il rapporto tra l'Utente e il soggetto erogatore del
        Servizio (UGO pnp).
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            id="ugoTermini"
            name="ugoTermini"
            checked={!!values.ugoTermini}
            onChange={onChange("ugoTermini")}
            sx={cbSx}
            required
          />
        }
        label={
          <Typography variant="body2" sx={{ fontSize: "11px" }}>
            Accetto i{" "}
            <Link
              href="https://assets.ctfassets.net/sqy8sbi9hlp9/2ZfieTheM9dh3s6oduloRg/770b144744e2ba1b3d8878cbabf9718f/T_C_SHORT_UGO_31.03.2026.pdf"
              color="#000000"
              sx={{ fontWeight: "bold" }}
              target="_blank"
              rel="noopener"
            >
              Termini e Condizioni
            </Link>{" "}
            UGO pnp
          </Typography>
        }
        sx={labelSx}
      />

      <FormControlLabel
        control={
          <Checkbox
            id="ugoPrivacy"
            name="ugoPrivacy"
            checked={!!values.ugoPrivacy}
            onChange={onChange("ugoPrivacy")}
            sx={cbSx}
            required
          />
        }
        label={
          <Typography variant="body2" sx={{ fontSize: "11px" }}>
            Accetto l'{" "}
            <Link
              href="https://hellougo.com/static/a60c14745611b0466d5e990484651da3/UGO_PP_Ugo.pdf"
              color="#000000"
              sx={{ fontWeight: "bold" }}
              target="_blank"
              rel="noopener"
            >
              Informativa Privacy
            </Link>{" "}
            UGO pnp
          </Typography>
        }
        sx={labelSx}
      />

      <FormControlLabel
        control={
          <Checkbox
            id="ugoConsenso"
            name="ugoConsenso"
            checked={!!values.ugoConsenso}
            onChange={onChange("ugoConsenso")}
            sx={cbSx}
            required
          />
        }
        label={
          <Typography variant="body2" sx={{ fontSize: "11px" }}>
            Consenso al trattamento dei dati ai sensi dell'art. 7 Reg. (UE)
            2016/679
          </Typography>
        }
        sx={labelSx}
      />

      {/* ── Testo conclusivo ────────────────────────────────────────── */}
      <Typography sx={{ fontSize: "11px", pt: 1.5, color: "text.secondary" }}>
        Il completamento della procedura di registrazione comporta l'integrale
        accettazione di tutti i documenti sopra indicati. In mancanza di tale
        accettazione, non sarà possibile procedere con la registrazione alla
        Piattaforma né usufruire dei Servizi.
      </Typography>
    </Box>
  );
}
